import { render, staticRenderFns } from "./UdfRuntimes.vue?vue&type=template&id=1a97e46e&shadow"
import script from "./UdfRuntimes.vue?vue&type=script&lang=js&shadow"
export * from "./UdfRuntimes.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./UdfRuntimes.vue?vue&type=style&index=0&id=1a97e46e&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports